import React from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from '../../hooks/i18n';
import { WarningFilled } from '@hangar/react-icons/core/interaction/WarningFilled';
import * as S from './styles/ItineraryComparison.style';

export const PartializedLoadInTransitMessage: React.FC = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const iconColor = theme?.tokens?.color?.icon?.info ?? '#0d12ab';
    
    return (
        <S.PartializedLoadBadge role="status" aria-label={t('itinerary.partializedLoadInTransit')}>
            <S.PartializedLoadIcon aria-hidden="true">
                <WarningFilled size={16} color={iconColor} />
            </S.PartializedLoadIcon>
            <S.PartializedLoadText>
                {t('itinerary.partializedLoadInTransit')}
            </S.PartializedLoadText>
        </S.PartializedLoadBadge>
    );
};

